module.exports = __webpack_public_path__ + "static/img/gold.c6b2bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/gold.png
// module id = oyZv
// module chunks = 35